import { ChangeEvent, useState } from "react";

import { Checkbox, Input } from "@newsela/angelou";

import {
  checkBoxListCss,
  listItemCss,
  todoCss,
  optionTextCss,
} from "./ToDoSection.style";

interface ToDoSectionProps {
  options: string[];
  useBulletPoints?: boolean;
  isCompleted: boolean;
  numberOfIncompleteQuestions?: number;
}

const ToDoSection = ({
  options,
  useBulletPoints,
  isCompleted,
  numberOfIncompleteQuestions,
}: ToDoSectionProps) => {
  const [selectedOptions, setSelectedOptions] = useState<string[]>([]);

  /**
   * This implementation should change once we integrate backend
   * @param event
   */
  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    const updatedSelectedOptions = isChecked
      ? [...selectedOptions, event.target.name]
      : [
          ...selectedOptions.filter(
            (selectedOption) => selectedOption !== event.target.name,
          ),
        ];
    setSelectedOptions(updatedSelectedOptions);
  };

  return (
    <>
      <div css={todoCss}>To do:</div>
      {!isCompleted ? (
        <div css={todoCss}>
          Action required: you have{" "}
          {numberOfIncompleteQuestions && numberOfIncompleteQuestions > 0
            ? numberOfIncompleteQuestions
            : ""}{" "}
          remaining questions to finish this section of Admin quick start.
        </div>
      ) : (
        <ul css={checkBoxListCss}>
          {options.map((option) => {
            return (
              <li key={option}>
                {!useBulletPoints && (
                  <>
                    <Checkbox
                      __cssFor={{ root: listItemCss }}
                      label={option}
                      name={option}
                      value={option}
                      onChange={handleCheckboxChange}
                    />
                    {option === "Other" && selectedOptions.includes(option) && (
                      <div>
                        <Input
                          label="Name of service"
                          placeholder="Name of service"
                          inputType={Input.inputTypes.text}
                        />
                      </div>
                    )}
                  </>
                )}

                {useBulletPoints && <div css={optionTextCss}>{option}</div>}
              </li>
            );
          })}
        </ul>
      )}
    </>
  );
};

export default ToDoSection;
